import DBs from './dbs.js'
import Indices from './indices.js'
import Tables from './tables.js'
import Search from './search.js'
import GETAssoc from './getassoc.js'
import Detail from './detail.js'

const repositories = {
  dbs: DBs,
  indices: Indices,
  tables: Tables,
  search: Search,
  rensou: GETAssoc,
  detail: Detail
};

export const Backend = {
  get: name => repositories[name]
};